import type { CSSProperties } from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyStyle = any;

/** Web pressable state (matches RN pattern) */
export type PressableStateType = { pressed: boolean; hovered: boolean; focused: boolean };

/**
 * Flatten/merge styles - Web implementation
 * Merges style objects, flattening nested RN-style arrays and dropping falsy values
 */
export function flattenStyles(styles: AnyStyle[]): CSSProperties {
  return styles
    .flat(Infinity)
    .filter(Boolean)
    .reduce((acc, style) => ({ ...acc, ...style }), {});
}
